import React, { useEffect, useState } from 'react';
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import './LatestUpdates.css';
import { Link } from 'react-router-dom';
import Heading from '../../../utls/Heading';

import jsonp from 'jsonp';
import moment from 'moment';

const LatestUpdates = () => {
    const [blogs, setBlogs] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchBlogs = async () => {
            try {
                const response = await fetch('https://blueberry-travel.com/blog1/List1', {
                    method: 'GET',
                });

                if (!response.ok) {
                    const errorText = await response.text();
                    throw new Error(`Failed to fetch: ${response.status} - ${errorText}`);
                }

                const data = await response.json();
                setBlogs(Array.isArray(data) ? data : []);
            } catch (error) {
                setError(error.message);
                console.error('Error fetching blogs:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchBlogs();
    }, []);

    // const fetchBlogs = async () => {
    //     try {
    //         const response = await fetch('/blog1/List1', {
    //             method: 'GET',
    //         });

    //         if (!response.ok) {
    //             const errorText = await response.text();
    //             throw new Error(`Failed to fetch: ${response.status} - ${errorText}`);
    //         }

    //         const data = await response.json();
    //         console.log('Raw Response Data:', data);

    //         // If the response includes HTML, process it as needed
    //         const processedBlogs = Array.isArray(data)
    //             ? data.map(blog => ({
    //                   ...blog,
    //                   Content: blog.Content ? blog.Content.replace(/<\/?[^>]+(>|$)/g, '') : '',
    //               }))
    //             : [];

    //         setBlogs(processedBlogs);
    //     } catch (error) {
    //         setError(error.message);
    //         console.error('Error fetching blogs:', error);
    //     } finally {
    //         setLoading(false);
    //     }
    // };


    if (loading) return <p>Loading...</p>;
    if (error) return <p>Error: {error}</p>;

    return (
        <>
            <div className="container latest-update mt-md-12 mb-4 px-lg-5">
                <div className="row">
                    <div className="col-md-12 mt-5">
                        <Heading className="headings mt-lg-3">
                            <span>Latest Updates</span> on Business Travel
                        </Heading>
                        <p className="fs3 mt-3">
                            All Things Travel: <b>Updates and Insights</b>
                        </p>
                        <p className="fs6 mt-2 para ">
                            From business travel hacks to leisure getaways, our blog keeps you up-to-date on all things travel-related. Join the conversation!
                        </p>
                    </div>
                </div>
            </div>

            <div className="container blogs px-lg-5">
                <div className="row">
                    <div className="col-xxl-7 col-lg-7 col-md-12 col-12">
                        {blogs.slice(1, 5).map((blog) => {
                            const formattedDate = blog?.CreatedDate
                                ? moment(blog.CreatedDate, 'MMM DD YYYY hh:mmA').format('MMM DD, YYYY')
                                : 'N/A';

                            const formattedTime = blog?.CreatedDate
                                ? moment(blog.CreatedDate, 'MMM DD YYYY hh:mmA').format('hh:mm A')
                                : 'N/A';

                            return (
                                <div key={blog.ArticleId} className="div mainBlogContainer my-5">
                                    <LazyLoadImage
            effect="blur"

                                        src={`${blog.Thumbnail}`}
                                        alt={blog.Title}
                                        className="w-100"  loading="lazy" 
                                    />
                                    <h5 className="headings latest-update-heading mt-4">{blog.Title}</h5>
                                    <div className="d-flex">
                                        <p className="fs5 mt-lg-4 mt-md-2 mt-3 ps-2">
                                            <b>
                                                <Link to={`/blog/${blog.Slug}`} style={{ textDecoration: 'none', color: "rgba(2, 97, 158, 1)" }}>
                                                    Read More
                                                </Link>
                                            </b>
                                        </p>
                                        <Link to={`/blog/${blog.Slug}`} style={{ textDecoration: 'none' }}>
                                            <button className="arrow-btn border-0 bg-transparent d-flex justify-content-center align-items-center mt-lg-3 ms-2 ms-lg-3">
                                                <LazyLoadImage
            effect="blur"
 src="https://blueberrywebsites.azureedge.net/bbt/icons/Right%20arrow.png" alt="right-arrow"  loading="lazy" />
                                            </button>
                                        </Link>
                                    </div>

                                    <div className="border-line mt-lg-2 mb-lg-2 w-100"></div>
                                    <div className="row">
                                        <div className="col-xxl-8 col-lg-8 col-md-12">
                                            <div className="time d-flex gap-3 flex-wrap"> {/* Added flex-wrap for better responsive behavior */}
                                                {/* Created Date */}
                                                <div className="calendar d-flex gap-2 align-items-center blogiconfont">
                                                    <LazyLoadImage
            effect="blur"
 src="https://blueberrywebsites.azureedge.net/bbt/icons/calendar.svg" alt="Calendar Icon"  loading="lazy" />
                                                    <p className="mt-3 p">{formattedDate}</p>
                                                </div>

                                                {/* Created Time */}
                                                <div className="time d-flex gap-2 align-items-center blogiconfont">
                                                    <LazyLoadImage
            effect="blur"
 src="https://blueberrywebsites.azureedge.net/bbt/icons/clock.svg" alt="Clock Icon"  loading="lazy" />
                                                    <p className="mt-3 p" >{formattedTime}</p>
                                                </div>
                                                {/* Views */}
                                                <div className="eye d-flex gap-2 align-items-center blogiconfont">
                                                    <LazyLoadImage
            effect="blur"
 src="https://blueberrywebsites.azureedge.net/bbt/icons/eye.svg" alt="Eye Icon" loading="lazy" />
                                                    <p className="mt-3 p">{blog?.Views || 0} Views</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-xxl-4 col-lg-4 col-md-12">
                                            <div className="social-logos d-flex gap-2 mt-md-2 justify-content-xxl-end">
                                                {/* WhatsApp */}
                                                <a
                                                    href={`https://wa.me/?text=${encodeURIComponent(window.location.origin + `/blog/${blog.Slug}`)}`}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                >
                                                    <LazyLoadImage
            effect="blur"
 src="https://blueberrywebsites.azureedge.net/bbt/icons/wattsaapp.svg" alt="Share on WhatsApp" loading="lazy" />
                                                </a>

                                                {/* Twitter */}
                                                <a
                                                    href={`https://twitter.com/intent/tweet?url=${encodeURIComponent(window.location.origin + `/blog/${blog.Slug}`)}&text=${encodeURIComponent(blog.Title)}`}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                >
                                                    <LazyLoadImage
            effect="blur"
 src="https://blueberrywebsites.azureedge.net/bbt/icons/twitter.svg" alt="Share on Twitter" loading="lazy" />
                                                </a>

                                                {/* Facebook */}
                                                <a
                                                    href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(window.location.origin + `/blog/${blog.Slug}`)}`}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                >
                                                    <LazyLoadImage
            effect="blur"
 src="https://blueberrywebsites.azureedge.net/bbt/icons/facebook.svg" alt="Share on Facebook" loading="lazy" />
                                                </a>
                                            </div>
                                        </div>

                                    </div>

                                </div>
                            );
                        })}
                    </div>





                    <div className="col-md-1 d-md-none d-xxl-block d-none"></div>
                    <div className="col-xxl-4 col-lg-4 col-md-12 col-12 mt-4 pt-2 ms-lg-5 ms-xxl-0">
                        <h3 className="headings ms-4 mt-2">
                            Recent <span>Blogs</span>
                        </h3>
                        {blogs.slice(4, 18).map((blog) => (
                            <div
                                key={blog.ArticleId}
                                className="mainBlogContainer1 blog-box mt-3 mb-xxl-4 mb-lg-4 mb-md-4"
                            >
                                <Link to={`/blog/${blog.Slug}`} style={{ textDecoration: 'none' }}>
                                    <div className="d-flex gap-2">
                                        <div className="img-box w-50">
                                            <LazyLoadImage
            effect="blur"

                                                style={{ width: "100%", height: "100%" }}
                                                src={`${blog.Thumbnail}`}
                                                alt={blog.Title}  loading="lazy" 
                                            />
                                        </div>
                                        <div className="text-box w-50">
                                            <p
                                                className="pt-1  fw-bold recent-blog-p"
                                                style={{ textDecoration: 'none', color: "black" }}
                                            >
                                                {blog.Title}
                                            </p>
                                            <div className="d-flex ms-1 mt-xxl-3 gap-1 top blogiconfont">
                                                <LazyLoadImage
            effect="blur"
 src="https://blueberrywebsites.azureedge.net/bbt/icons/calendar2.svg" alt=""  loading="lazy"  />
                                                <span className="">
                                                    {blog.CreatedDate ?
                                                        moment(blog.CreatedDate, 'MMM DD YYYY  h:mmA')
                                                            .format('MMM DD, YYYY')
                                                        : 'Date not available'
                                                    }
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </Link>
                            </div>
                        ))}
                    </div>

                </div>
            </div>
        </>
    );
};

export default LatestUpdates;
